module.exports = __webpack_public_path__ + "images/9853267.jpg";